<template lang="pug">
  b-modal.reminder-modal(
    ref="modal"
    :title="`Recordatorio — ${businessName}`"
    v-bind="$attrs"
    @show="onShow"
    @ok="onSubmit"
    @hidden="onHidden"
    :ok-disabled="loading"
    :cancel-disabled="loading"
    ok-title="Guardar"
    cancel-title="Cancelar"
    size="lg"
  )
    b-form
      b-form-group
        template(#label)
          .d-flex.align-items-center.mb-1
            font-awesome-icon(:icon="['far', 'comment-dots']" class="mr-2" style="color: #F6C90E;")
            span.font-weight-bold Recordatorio del cliente
        b-form-textarea(
          v-model="reminderText"
          placeholder="Escribe un recordatorio para este cliente..."
          rows="8"
          max-rows="16"
          :disabled="loading"
          style="resize: vertical; font-size: 0.95rem; line-height: 1.6;"
        )
      .text-muted.small.mt-1
        font-awesome-icon(:icon="['fas', 'info-circle']" class="mr-1")
        | Este recordatorio es visible y editable por todo el equipo. No está asociado a ningún período.
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ReminderModal',
  inheritAttrs: false,
  data () {
    return {
      businessId: null,
      businessName: '',
      reminderText: '',
      loading: false
    }
  },
  methods: {
    ...mapActions(['updateBusinessReminder']),
    show (business) {
      this.businessId = business.client ? business.client.id : business.id
      this.businessName = business.client ? business.client.name : business.name
      this.reminderText = business.client ? (business.client.reminder || '') : (business.reminder || '')
      this.$refs.modal.show()
    },
    onShow () {
      this.loading = false
    },
    onHidden () {
      this.reminderText = ''
      this.businessId = null
      this.businessName = ''
    },
    async onSubmit (e) {
      e.preventDefault()
      this.loading = true
      try {
        const response = await this.updateBusinessReminder({ id: this.businessId, reminder: this.reminderText || null })
        if (response && response.status >= 400) {
          throw new Error(response.data || 'Error al guardar')
        }
        this.$root.$bvToast.toast('Recordatorio guardado correctamente', {
          title: 'Éxito',
          variant: 'success',
          autoHideDelay: 3000
        })
        this.$emit('reminder-saved', { id: this.businessId, reminder: this.reminderText || null })
        this.$refs.modal.hide()
      } catch (error) {
        const message = error.message || 'Error desconocido al guardar el recordatorio'
        this.$root.$bvToast.toast(message, {
          title: 'Error',
          variant: 'danger',
          autoHideDelay: 5000
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
::v-deep .modal-title {
  font-weight: 600;
}
::v-deep .modal-body {
  padding: 1.25rem 1.5rem;
}
</style>
